import { DefaultApi as HyliaApiClient } from '@peartherapeutics/hylia-api-client';
import { getConfig } from 'utils/config';
import { sessionGet, SessionKeys } from 'utils/tokenStorage';
import axios, { AxiosError, AxiosInstance, AxiosRequestHeaders } from 'axios';
import ApiError from 'apis/apiError';
import { iframePostMessage } from 'utils/constants';

let hyliaApiClientPromise: Promise<HyliaApiClient>;

function getHeaders() {
  const headers: AxiosRequestHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
    Authorization: `JWT ${sessionGet(SessionKeys.AUTH_TOKEN)}`,
  };
  const user_context = sessionGet(SessionKeys.USER_CONTEXT);
  if (user_context) {
    headers.user_context = user_context;
  }
  return headers;
}

function handleErrors(error: AxiosError) {
  if (error.response?.status === 401) {
    window.parent.postMessage(
      {
        payload: {
          action: iframePostMessage.EXPIRED_TOKEN,
        },
      },
      sessionGet(SessionKeys.ORIGIN)!,
    );
    throw new ApiError({
      status: error.response.status,
      statusText: error.response.statusText,
    });
  }
  throw new ApiError({
    message: `Remote API server did not respond: ${error.request.url}`,
  });
}

function getAxiosInstance(baseURL: string): any {
  const headers: AxiosRequestHeaders = getHeaders();
  const instance = axios.create({
    baseURL,
    headers,
  });
  instance.interceptors.response.use(undefined, handleErrors);
  return instance;
}

export default async function getHyliaApiClient(): Promise<HyliaApiClient> {
  const { HYLIA_API_URL } = await getConfig();

  // Caches client for subsequent calls.
  if (!hyliaApiClientPromise) {
    const hyliaClient = new HyliaApiClient(
      undefined,
      HYLIA_API_URL,
      getAxiosInstance(HYLIA_API_URL),
    );

    hyliaApiClientPromise = Promise.resolve(hyliaClient);
  }

  return hyliaApiClientPromise;
}
